export default {"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82};